import { render, staticRenderFns } from "./RvsForm.vue?vue&type=template&id=aeaa3abc&scoped=true"
import script from "./RvsForm.vue?vue&type=script&lang=ts"
export * from "./RvsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaa3abc",
  null
  
)

export default component.exports